import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsertAddressMutationVariables = Types.Exact<{
  input: Types.Addresses_Insert_Input;
}>;


export type InsertAddressMutation = { __typename?: 'mutation_root', insert_addresses_one?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string, created_at: any, updated_at: any } | null };


export const InsertAddressDocument = gql`
    mutation insertAddress($input: addresses_insert_input!) {
  insert_addresses_one(object: $input) {
    id
    street_1
    street_2
    city
    state
    postal_code
    country
    created_at
    updated_at
  }
}
    `;
export type InsertAddressMutationFn = Apollo.MutationFunction<InsertAddressMutation, InsertAddressMutationVariables>;

/**
 * __useInsertAddressMutation__
 *
 * To run a mutation, you first call `useInsertAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAddressMutation, { data, loading, error }] = useInsertAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertAddressMutation(baseOptions?: Apollo.MutationHookOptions<InsertAddressMutation, InsertAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAddressMutation, InsertAddressMutationVariables>(InsertAddressDocument, options);
      }
export type InsertAddressMutationHookResult = ReturnType<typeof useInsertAddressMutation>;
export type InsertAddressMutationResult = Apollo.MutationResult<InsertAddressMutation>;
export type InsertAddressMutationOptions = Apollo.BaseMutationOptions<InsertAddressMutation, InsertAddressMutationVariables>;